import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  FormGroup,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,

} from '@mui/material';
import { useStyles } from '../Styles';

export default function DeleteButton(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <FormGroup>
      <Button
        style={{ borderRadius: '15px' }}
        variant="contained"
        color="secondary"
        className={classes.rootDelete}
        startIcon={<DeleteIcon />}
        size="large"
        onClick={handleClickOpen}
        disabled={props.disabled}
      >
        Apagar
      </Button>
      <FormGroup>
        <Dialog open={open} onClose={handleClose} aria-labelledby="alert">
          <DialogTitle id="alert">{props.message}</DialogTitle>
          <DialogActions style={{ padding: '0rem 1.5rem 1.5rem 0rem' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              style={{
                border: '1px solid red',
                color: 'red',
              }}
            >
              Não
            </Button>
            <Button
              onClick={() => {
                props.onClick();
                return handleClose();
              }}
              style={{
                backgroundColor: '#0267C1',
                color: 'white',
              }}
            >
              Sim
            </Button>
          </DialogActions>
          {/* <DialogActions>
            <Button
              onClick={handleClose}
              style={{
                backgroundColor: "red",
                color: "white",
                borderRadius: "15px",
              }}
              size="large"
            >
              Não
            </Button>
            <Button
              onClick={() => {
                props.onClick();
                return handleClose();
              }}
              style={{
                backgroundColor: "#0076C6",
                color: "white",
                borderRadius: "15px",
              }}
              size="large"
              type="submit"
            >
              Sim
            </Button>
          </DialogActions> */}
        </Dialog>
      </FormGroup>
    </FormGroup>
  );
}
